import { render, staticRenderFns } from "./quality-assurance-agency-detail.vue?vue&type=template&id=4aaf68a3&scoped=true&"
import script from "./quality-assurance-agency-detail.vue?vue&type=script&lang=js&"
export * from "./quality-assurance-agency-detail.vue?vue&type=script&lang=js&"
import style0 from "./quality-assurance-agency-detail.vue?vue&type=style&index=0&id=4aaf68a3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaf68a3",
  null
  
)

export default component.exports